__turbopack_context__.v({
  "arrow": "tooltip-module-scss-module__EhW_Oq__arrow",
  "bottom": "tooltip-module-scss-module__EhW_Oq__bottom",
  "bottomEnd": "tooltip-module-scss-module__EhW_Oq__bottomEnd",
  "bottomStart": "tooltip-module-scss-module__EhW_Oq__bottomStart",
  "bullet": "tooltip-module-scss-module__EhW_Oq__bullet",
  "container": "tooltip-module-scss-module__EhW_Oq__container",
  "content": "tooltip-module-scss-module__EhW_Oq__content",
  "darkTheme": "tooltip-module-scss-module__EhW_Oq__darkTheme",
  "error": "tooltip-module-scss-module__EhW_Oq__error",
  "errorContainer": "tooltip-module-scss-module__EhW_Oq__errorContainer",
  "firstCol": "tooltip-module-scss-module__EhW_Oq__firstCol",
  "grouped": "tooltip-module-scss-module__EhW_Oq__grouped",
  "hasIcon": "tooltip-module-scss-module__EhW_Oq__hasIcon",
  "icon": "tooltip-module-scss-module__EhW_Oq__icon",
  "iconCol": "tooltip-module-scss-module__EhW_Oq__iconCol",
  "left": "tooltip-module-scss-module__EhW_Oq__left",
  "leftEnd": "tooltip-module-scss-module__EhW_Oq__leftEnd",
  "leftStart": "tooltip-module-scss-module__EhW_Oq__leftStart",
  "limitRow": "tooltip-module-scss-module__EhW_Oq__limitRow",
  "listGroupTitle": "tooltip-module-scss-module__EhW_Oq__listGroupTitle",
  "listItem": "tooltip-module-scss-module__EhW_Oq__listItem",
  "listNumber": "tooltip-module-scss-module__EhW_Oq__listNumber",
  "listText": "tooltip-module-scss-module__EhW_Oq__listText",
  "listWrapper": "tooltip-module-scss-module__EhW_Oq__listWrapper",
  "nontouchable": "tooltip-module-scss-module__EhW_Oq__nontouchable",
  "otherCol": "tooltip-module-scss-module__EhW_Oq__otherCol",
  "right": "tooltip-module-scss-module__EhW_Oq__right",
  "rightEnd": "tooltip-module-scss-module__EhW_Oq__rightEnd",
  "rightStart": "tooltip-module-scss-module__EhW_Oq__rightStart",
  "tableWrapper": "tooltip-module-scss-module__EhW_Oq__tableWrapper",
  "textFormat": "tooltip-module-scss-module__EhW_Oq__textFormat",
  "tooltip": "tooltip-module-scss-module__EhW_Oq__tooltip",
  "top": "tooltip-module-scss-module__EhW_Oq__top",
  "topEnd": "tooltip-module-scss-module__EhW_Oq__topEnd",
  "topStart": "tooltip-module-scss-module__EhW_Oq__topStart",
});
